import { provideSingleton } from '../inversify';

@provideSingleton(Configuration)
class Configuration {
  /**
   * The endpoint (i.e. the domain of the URL) of the socket of the bus backend.
   */
  public socketIoEndpoint() {
    return window.location.protocol === 'http:' ? 'https://stadtbus.lemgo-digital.de' : '/';
  }

  /**
   * The path endpoint (i.e. the path of the URL) of the socket of the bus backend.
   */
  public socketIoPath() {
    return '/api_sock';
  }

  /**
   * The api base for the RESTful API of the bus backend.
   */
  public apiBaseUrl() {
    return window.location.protocol === 'http:' ? 'https://stadtbus.lemgo-digital.de/api' : '/api';
  }
}

export default Configuration;



// WEBPACK FOOTER //
// ./src/api/configuration.ts